module.exports = __webpack_public_path__ + "assets/img/close_cross.svg";